import GeneralFilter from '../../../../Model/GeneralFilter'

export default class CountryFilter extends GeneralFilter {
  constructor () {
    super()
    this.setInitialValue()
  }

  setInitialValue () {
    this.setFilterInitialValue()
  }
}
